module.exports = __webpack_public_path__ + "img/Luce.f9bed59c.png";